import SignUpForm from "@/components/form/signup";
import Game from "@/components/game";
import { Button } from "@/components/ui/button";
import { useAppStore } from "@/store/app";
import { useCallback, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { FaTimesCircle } from "react-icons/fa";
import { getPartners } from "@/services/parceiros";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import banner from "@/assets/img/topo.png";
//import bgScroller from "@/assets/img/bg-flower.svg";
import cartoes from "@/assets/img/anuidade.png";
import leiaute from "@/assets/img/leiaute.png";
import tags from "@/assets/img/tags.png";
import lci from "@/assets/img/lci.png";

import bbSeguros from "@/assets/img/bb-seguros.png";
import bb from "@/assets/img/bb.png";
import p from "@/assets/img/p.png";


export default function LandingPage() {
  const { user, logout } = useAppStore();

  const [displayGame, setDisplayGame] = useState(false);
  const [partners, setTPartners] = useState<any>([]);

  const handleOpenGame = useCallback(() => {
    setDisplayGame(true);
  }, []);

  const handleQuitGame = useCallback(() => {
    setDisplayGame(false);
    logout();
  }, [logout]);

  
    useEffect(() => {
      async function loadData() {
        const resp = await getPartners();
        setTPartners(resp);
      }
  
      loadData();
    }, []); 

    const responsive = {
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 5,
        slidesToSlide: 1 // optional, default to 1.
      },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 5,
        slidesToSlide: 1 // optional, default to 1.
      },
      mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
      }
    };

  return (
    <>
      {displayGame ? (
        <FaTimesCircle
          size={40}
          className="absolute z-40 top-5 right-5 text-black opacity-50 w-[40px] h-[40px] closeItem"
          onClick={() => handleQuitGame()}
        />
      ) : null}
      {displayGame &&
        createPortal(
          <div className="relative top-0 left-0 w-full h-full z-20 bg-opacity-80 flex items-center justify-center">
            <div className="w-full h-full relative bg-white">
              {user ? <Game onQuit={handleQuitGame} /> : <SignUpForm />}
            </div>
          </div>,
          document.body,
        )}

      {!displayGame && (
        <div>
          <div
            className="flex w-full h-[600px] relative bg-no-repeat bg-cover bg-right"
            style={{
              backgroundImage: `url(${banner})`,
              backgroundSize: "100% 100%"
            }}
          >
            <div className="flex flex-col items-start justify-around p-20">
              {/* <img src={logo} alt="logo" className="w-auto h-[124px]" /> */}

              {/* <div className="flex flex-col gap-10">
                <h1 className="text-6xl font-bold">
                  UM 
                  <br />
                  Brasil
                </h1>
                <p>De oportunidades</p>
                <p>
                  Para tudo que <br /> <strong>o seu município</strong> imaginar.
                </p>
              </div> */}
            </div>
          </div>
          <div className="bg-[#1F60FF] gap-8 flex flex-col items-center justify-center p-16 text-center">
            <h3 className="text-4xl font-bold">Quiz programa BB valorizando os professores do Brasil</h3>
            <Button
              onClick={() => handleOpenGame()}
              className="text-lg p-6 uppercase font-bold"
            >
              Participar do Quiz
            </Button>
          </div>
          <div className="bg-[#00ECD0] gap-8  justify-center p-16 text-center">
            <h3 className="text-4xl  text-[#1F60FF]">
              Segurança, praticidade e vantagens exclusivas: <br />
              tudo isso com o cartão <b>Mais professores</b>
            </h3>
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 text-[#1F60FF]">
              <div className="flex flex-col items-center">
                <img src={cartoes} alt="" className="mb-3"/>
                <p>Cartões com <br /> anuidade grátis</p>
              </div>
              <div className="flex flex-col items-center">
                <img src={leiaute} alt="" className="mb-3"/>
                <p>Cartão com <br /> leiaute exclusivo</p>
              </div>
              <div className="flex flex-col items-center">
                <img src={tags} alt="" className="mb-3"/>
                <p>Duas TAGs <br /> BB grátis</p>
              </div>
              <div className="flex flex-col items-center">
                <img src={lci} alt="" className="mb-3"/>
                <p>LCI com taxa <br /> diferenciada</p>
              </div>
            </div>
          </div>

                
          <div className="bg-[#F0F2F4] gap-8  ustify-center p-16 text-center">
            <h3 className="text-3xl  text-[#1F60FF] mb-10">
              Ofertas e vantagens com parceiros
            </h3>
            
            <Carousel
              swipeable={false}
              draggable={true}
              showDots={true}
              responsive={responsive}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
              keyBoardControl={false}
              transitionDuration={500}
              containerClass="carousel-container"
              removeArrowOnDeviceType={["tablet", "mobile"]}
              dotListClass="custom-dot-list-style"
              itemClass="carousel-item-padding-40-px"
            >
              {partners.map((item: any, i: number) => (
                <div key={i} className="bg-[#fff] mx-4 w-[170px] h-[180px] rounded mb-10">
                  <div className="image">
                    <img
                      src={item.image.medium.url}
                      alt={item.title}
                      title={item.title}
                      className="w-full h-[90px] mb-4 rounded-tl-sm rounded-tr-sm rounded-bl-none rounded-br-none"
                    />
                  </div>
                  <div className="content text-[#6C7077] text-[11px] text-left px-3 leading-[1.2]">
                    {item.link ? (
                      <a href={item.link} target="_blank">
                        {item.description}
                      </a>
                    ) : (
                      <span>{item.description}</span>
                    )}
                  </div>
                </div>
              ))}
            </Carousel>
          </div>

          <div
            className="bg-[#1F60FF] px-20 py-10 bg-right bg-no-repeat bg-contain flex items-center"
          >
            <div className="space-y-6 flex-1">
              <div className="flex gap-5">
                <img src={bb} alt="" />
                <img src={p} alt="" />
                <img src={bbSeguros} alt="" className="h-[40px] mt-4"/>
              </div>
              <div className="opacity-60">
                https://www.bb.com.br/site/pra-voce/profissional-liberal-e-socio-dirigente-de-empresa/professores/
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
